export default
{
	icons: [
		{
			name: "blinds",
			x: 1012,
			y: 315
		},
		{
			name: "clock",
			x: 1610,
			y: 92.25
		},
		{
			name: "whiteboard",
			x: 1720.9,
			y: 446.05
		},
		{
			name: "drip",
			x: 760.95,
			y: 328.9
		},
		{
			name: "breakfast",
			x: 284,
			y: 526
		},
		{
			name: "talk2pat",
			x: 526,
			y: 467.05
		},
		{
			name: "exit",
			x: 948,
			y: 950.05
		},
		{
			name: "zweedseBand",
			x: 649,
			y: 526.05
		},
		{
			name: "glasses",
			x: 324,
			y: 540
		},
		{
			name: "medication",
			x: 591,
			y: 486.5
		},
		{
			name: "water",
			x: 205.5,
			y: 502.5
		},
		{
			name: "shower",
			x: 817,
			y: 560.05
		}
	],
	objects: [
		{
			name: "clock",
			x: 1569,
			y: 0
		},
		{
			name: "whiteboard",
			x: 1552,
			y: 512
		}
	]
}